<template>
  <v-card>
    <v-card-title class="title">
      <img class="mr-1" src='https://img.icons8.com/color/56/0000000/slug-eating.png' alt />
      {{`${item.patient.name} ${item.patient.lastName}`}}
    </v-card-title>
    <div class="detail">
      <div class="detail-goal">
        <p class="mx4">
          <i class="fas fa-balance-scale"></i>
          {{item.patient.body}} kg
        </p>
        <p class="mx4">
          <i class="fas fa-sun" style="color: #ff5e00bd;"></i>
          {{item.patient.cal}} kcal/mL
        </p>
        <p class="mx4">
          <i class="fas fa-dna" style="color: #29a92e;"></i>
          {{item.patient.protein}} gPTN/kg
        </p>
        <p class="mx4">
          <i class="fas fa-tint" style="color: #2196f3;"></i>
          {{item.patient.volume}} mL da dieta {{item.diet.title}}
        </p>
      </div>
      <div class="detail-btn">
        <v-card-actions>
          <v-btn @click="more()" large style="background: rgb(0, 96, 100);">
            <i style="font-size: 2.2rem; color: #fff;" class="fas fa-chart-area"></i>
          </v-btn>
        </v-card-actions>
        <span>Registro: {{date}}</span>
      </div>
    </div>
    <v-dialog v-model="dialog" max-width="500">
      <app-results v-if="dialog" :toCalculate="toCalculate"></app-results>
    </v-dialog>
  </v-card>
</template>

<script>
export default {
  name: "appItem",
  data() {
    return {
      dialog: false,
      date: this.item.date.toDate().toLocaleDateString("pt-BR"),
      toCalculate: {
        patient: "",
        diet: ""
      }
    };
  },
  props: {
    item: {
      required: true
    }
  },
  methods: {
    more() {
      this.toCalculate.patient = this.item.patient;
      this.toCalculate.diet = this.item.diet;
      this.dialog = true;
    }
  },
  components: {
    appResults: () => import("../form/Results")
  }
};
</script>

<style lang="scss" scoped>
.title,
.detail,
.detail-goal {
  display: flex;
}

.title {
  justify-content: center;
}

.title img {
  height: 35px;
  will-change: 35px;
}

.detail {
  align-items: stretch;
  padding: 0 10px;
  flex-direction: column;
}

.detail p {
  margin-bottom: 15px;
}

.detail-goal {
  align-items: flex-start;
  flex-wrap: wrap;
  justify-content: space-around;
}

.detail-btn {
  flex-grow: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.detail-btn span {
  font-size: 0.7rem;
  align-self: flex-end;
  bottom: 2px;
}

.mx4 {
  margin-right: 4px;
  margin-left: 4px;
}
</style>>